import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'

export const ListImageBoxSettings = (props) => {

  const imageVariantOpts = [
    { label: 'Normale', value: '' },
    { label: 'Bordo arrotondato', value: 'radius' },
  ]
  const imagePosOpts = [
    { label: 'Alto', value: 'top' },
    { label: 'Basso', value: 'bottom' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="title"
          type="text"
          label="Titolo"
          defaultValue={defaultProps['title']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="imagePos"
          type="select"
          options={imagePosOpts}
          label="Posizione immagine"
          defaultValue={defaultProps['imagePos']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="imageVariant"
          type="select"
          options={imageVariantOpts}
          label="Stile immagine"
          defaultValue={defaultProps['imageVariant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="src"
          type="text"
          label="Src"
          description="Paste your url or upload a file"
          defaultValue={defaultProps['src']}
        />
        <ToolbarItem propKey="block" propSubKey="image" type="file" />
      </ToolbarSection>
    </>
  );
};
